import { render, staticRenderFns } from "./WOManageHandle.vue?vue&type=template&id=79a954ad&scoped=true&"
import script from "./WOManageHandle.vue?vue&type=script&lang=js&"
export * from "./WOManageHandle.vue?vue&type=script&lang=js&"
import style0 from "./WOManageHandle.vue?vue&type=style&index=0&id=79a954ad&prod&scoped=true&lang=css&"
import style1 from "./WOManageHandle.vue?vue&type=style&index=1&id=79a954ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a954ad",
  null
  
)

export default component.exports